import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { LoaderService } from '../../core/services/loader.service';
import { AuthenticationService } from '../../core/services/authentication.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-nav-bar',
  imports: [CommonModule, RouterModule, TranslateModule, FormsModule],
  templateUrl: './nav-bar.component.html',
  styleUrl: './nav-bar.component.scss'
})
export class NavBarComponent {
  dropdownOpen = false;
  isBrowser: boolean;
  selectedLang: string = '';
  isSearchOpen = false;
  searchQuery = '';
  isUserLoaded = false;
  currentUser: any = null;

  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: object,
    private readonly cookieService: CookieService,
    public translate: TranslateService,
    public loaderService: LoaderService,
    private readonly router: Router,
    public authenticationService: AuthenticationService,
    private readonly http: HttpClient,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.selectedLang = this.translate.getCurrentLang();
    this.authenticationService.currentUser.subscribe(user => {
      this.currentUser = user;
      this.isUserLoaded = true;
    });
  }

  getUserName(user: any): string {
    let name = '';
    if (!user) return name;
    if (this.currentUser.RoleId == 1 || this.currentUser.RoleId == 4 || this.currentUser.RoleId == 6) {
      name = this.getInitials(user.CompanyName);
    } else if (user.FirstName && user.LastName) {
      name = user.FirstName.charAt(0).toUpperCase() + user.LastName.charAt(0).toUpperCase();
    } else if (user.FirstName) {
      name = user.FirstName.charAt(0).toUpperCase();
    }

    return name;
  }

  getInitials(text: string, limit = 2): string {
    return text?.trim().split(' ').filter(Boolean).map(w => w[0].toUpperCase()).slice(0, limit).join('') || '';
  }

  formatName(text: string): string {
    if (!text) return '';
    const parts = text.trim().split(' ');
    return parts[0] + (parts[1] ? ' ' + parts[1][0] : '');
  }

  changeLang(lang: 'de' | 'en' | 'es' | 'it') {
    this.cookieService.set('lang', lang, { expires: 365, path: '/', sameSite: 'Lax', secure: false });
    this.translate.use(lang);
    this.selectedLang = lang;
  }

  goToLogin() {
    if (this.isBrowser) {
      this.router.navigate(['/auth/login']);
    }
  }

  onSearch() {
    if (this.isBrowser) {
      this.router.navigate(['/search']);
    }
  }

  logout() {
    this.authenticationService.logout();
    if (this.isBrowser) {
      this.router.navigate(['/home']);
    }
  }

}
